<template>
    <div id="container">
<div id="content">
            <el-form v-if="semesters.length" class="term-select" label-position="left">
                <el-form-item label="Term:" >
                    <el-select style="width:150px;" size="mini" v-model="semesterId" @change="getRequests">
                        <el-option v-for="semester in semesters" :key="semester.id" :value="semester.id" :label="semester.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <h1>Note taking service recipients with at least one service with a hired note taker</h1>
            <note-taking-service-nav selected="recipients"></note-taking-service-nav>
            <p>To alter service information, click on the course name.</p>
            <el-table :default-sort="{prop: 'student_name', order: 'ascending'}" :data="requests">
                <el-table-column label="Student name" prop="student_name" sortable :sort-orders="['ascending', 'descending']" :min-width="8">
                    <template slot-scope="scope">
                        <a :href="'/student/services/' + scope.row.student_id">{{ scope.row.student_name }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Preferred name" prop="student_preferred_name" sortable :sort-orders="['ascending', 'descending']" :min-width="8"></el-table-column>
                <el-table-column label="Student status" prop="status_display" sortable :sort-orders="['ascending', 'descending']" :min-width="8"></el-table-column>
                <el-table-column label="Courses" prop="service_courses" sortable :sort-orders="['ascending', 'descending']" :min-width="30.5">
                    <template slot-scope="scope">
                        <template v-for="(course, index) in scope.row.service_courses">
                            <template v-if="index !== 0">, </template><a :key="index" :href="'/note-taking-service/show/' + course.service_id">{{ course.class_name }}</a>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="Accommodations" prop="accommodations" sortable :sort-orders="['ascending', 'descending']" :min-width="30.5">
                    <template slot-scope="scope">
                        <template v-for="accommodation in scope.row.accommodations">
                            {{ accommodation.name }}<template v-if="accommodation.description"> - {{ accommodation.description }}</template><template v-if="accommodation.comment"> - <span v-html="accommodation.comment" :key="accommodation.id"></span></template>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="Coordinator" prop="coordinator_name" sortable :sort-orders="['ascending', 'descending']" :min-width="8"></el-table-column>
            </el-table>
            <p v-if="total">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ({{ total }} records)</p>
        </div>
        </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo () {
            return {
                title: "Note taking service recipients with at least one service with a hired note taker"
            }
        },
        components: {
        },
        data () {
            return {
                requests: [],
                semesters: [],
                semesterId: null,
                total: null
            }
        },
        methods: {
            load: function() {
                axios.get('/api/simple/get-current-and-past-semesters')
                    .then(response => {
                        this.semesters = response.data.rows;
                        for(var i = 0; i < this.semesters.length; i++){
                            if(this.semesters[i].is_current){
                                this.semesterId = this.semesters[i].id;
                            }
                        }
                        this.getRequests();
                    });
            },
            getRequests: function() {
                axios.get('/api/notetaking-service/current-by-student/', {params: {semester_id: this.semesterId}})
                    .then(response => {
                        if(response.data.success) {
                            this.requests = response.data.rows;
                            this.total = response.data.total;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created () {
            this.load();
        }
    }
</script>
<style scoped>
    .term-select {
        width: 250px;
        float:right;
    }
    .el-table th {
        vertical-align: top;
    }
</style>
